//
// theme.js
//

// Vendor
import "../scss/style.scss";
import "bootstrap";

import "@fancyapps/ui";
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
library.add(fas, far, fab);
dom.i2svg();

// Theme
import "./aos";
import "./lozad";
import "./masonry";
import "./header";
import "./switcher";
import "./gotoTop";
import "./prism";
import "./form-validation";
import "./load-more";
import "./toasts";
import "./counters";
import "./scrollspy";
